import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
  // attorney slider
  const teamSwiper = new Swiper('.grid-attorney', {
    modules: [Navigation, Pagination, A11y],
    navigation: {
      nextEl: '.arrow-next',
      prevEl: '.arrow-prev',
    },
    loop: true,
    a11y: true,
    keyboardControl: true,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });
};
